import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";
import Login from "../views/login.vue";
import AboutUs from "../views/about/index.vue";
import Introduction from "../views/about/introduction.vue";
import Project from "../views/project/index.vue";
import ProjectDetail from "../views/project/detail.vue";
import ProjectList from "../views/project/list.vue";
import Contact from "../views/about/contact.vue";
import Join from "../views/about/join.vue";
import News from "../views/news/news.vue";
import NewsDetails from "../views/news/details.vue";
import UserView from "../views/user/index.vue";
import UserSetting from "../views/user/setting/index.vue";
import UserSettingEdit from "../views/user/setting/form.vue";
import UserMessage from "../views/user/message/index.vue";
import UserComments from "../views/user/comments/index.vue";
import UserCollection from "../views/user/collection/index.vue";
import UserProject from "../views/user/project/index.vue";
import UserTalent from "../views/user/talent/index.vue";
import UserTalentBasic from "../views/user/talent/form/basicForm.vue";
import UserTalentJob from "../views/user/talent/form/jobForm.vue";
import UserTalentWork from "../views/user/talent/form/workForm.vue";
import UserTalentEducation from "../views/user/talent/form/educationForm.vue";
import UserTalentMajor from "../views/user/talent/form/majorForm.vue";
import UserTalentProject from "../views/user/talent/form/projectForm.vue";
import Privacy from "../views/privacy.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "首页",
    component: Home
  },
  {
    path: "/login",
    name: "登录",
    component: Login
  },
  {
    path: "/privacy",
    name: "隐私声明",
    component: Privacy
  },
  {
    path: "/about",
    component: AboutUs,
    children: [
      {
        path: "/",
        component: Introduction
      },
      {
        path: "/about/introduction",
        name: "公司简介",
        component: Introduction
      },
      {
        path: "/about/contact",
        name: "联系我们",
        component: Contact
      },
      {
        path: "/about/join",
        name: "加入我们",
        component: Join
      }
    ]
  },
  {
    path: "/product",
    name: "产品中心",
    component: Project
  },
  {
    path: "/product/list",
    name: "项目列表",
    component: ProjectList
  },
  {
    path: "/product/projectDetails",
    name: "项目详情",
    component: ProjectDetail
  },
  {
    path: "/new",
    name: "新闻资讯",
    component: News
  },
  {
    path: "/new/details",
    name: "新闻资讯详情",
    header: "white",
    component: NewsDetails
  },
  {
    path: "/user",
    name: "我的账户",
    component: UserView,
    children: [
      //基本设置
      {
        path: "/user/setting",
        name: "基本设置",
        component: UserSetting
      },
      {
        path: "/user/setting/edit",
        name: "编辑基本设置",
        component: UserSettingEdit
      },
      //我的消息
      {
        path: "/user/message",
        name: "我的消息",
        component: UserMessage
      },
      //我的评论
      {
        path: "/user/comments",
        name: "我的评论",
        component: UserComments
      },
      //收藏
      {
        path: "/user/collection",
        name: "我的收藏",
        component: UserCollection
      },
      //项目
      {
        path: "/user/project",
        name: "我的项目",
        component: UserProject
      },
      //人才
      {
        path: "/user/talent",
        name: "人才信息",
        component: UserTalent
      },
      {
        path: "/user/talent/basicForm",
        name: "添加修改信息",
        component: UserTalentBasic
      },
      {
        path: "/user/talent/jobForm",
        name: "添加修改求职意向",
        component: UserTalentJob
      },
      {
        path: "/user/talent/workForm",
        name: "添加修改工作经历",
        component: UserTalentWork
      },
      {
        path: "/user/talent/educationForm",
        name: "添加修改教育经历",
        component: UserTalentEducation
      },
      {
        path: "/user/talent/majorForm",
        name: "添加修改专业能力",
        component: UserTalentMajor
      },
      {
        path: "/user/talent/projectForm",
        name: "添加修改项目经历",
        component: UserTalentProject
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.afterEach(() => {
  window, scrollTo(0, 0);
});
export default router;
